import PropTypes from 'prop-types';
import React, {useState} from 'react';

import BenchlingIcon, {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

import AbsoluteDropdownContainer from './AbsoluteDropdownContainer';
import Button, {ButtonSize, ButtonStyle} from './buttons/Button';

/**
 * Dropdown that renders an input next to a Set All button to bulk set values.
 */

interface SetAllDropdownRenderProps {
  setAll: () => void;
  close: () => void;
}

interface SetAllDropdownWrapperProps {
  children: JSX.Element | ((renderProps: SetAllDropdownRenderProps) => JSX.Element);
  isDisabled: boolean;
  onSetAll: () => void;
  icon?: BenchlingIconName;
}

export default function SetAllDropdownWrapper(props: SetAllDropdownWrapperProps): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);

  function close(): void {
    setIsOpen(false);
  }

  function handleSetAll(): void {
    props.onSetAll();
    close();
  }

  function renderChildren(): JSX.Element {
    if (typeof props.children === 'function') {
      return props.children({setAll: handleSetAll, close});
    }
    return props.children;
  }

  return (
    <AbsoluteDropdownContainer
      menu={
        <div className="dropdown-menu pull-right">
          <div className="setAllDropdown-menu">
            {renderChildren()}
            <Button
              buttonStyle={ButtonStyle.PRIMARY}
              className="u-flex-none u-tiny-spacing-left"
              disabled={props.isDisabled}
              onClick={handleSetAll}
              size={ButtonSize.MINI}
              text="Set All"
            />
          </div>
        </div>
      }
      onRequestClose={close}
      open={isOpen}
    >
      <BenchlingIcon
        className="u-mini-spacing-left u-pointer"
        icon={props.icon ?? 'collapse-down'}
        onClick={() => {
          setIsOpen(!isOpen);
        }}
      />
    </AbsoluteDropdownContainer>
  );
}

SetAllDropdownWrapper.propTypes = {
  // Input component (which can be treated as a render prop)
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,
  isDisabled: PropTypes.bool.isRequired,
  onSetAll: PropTypes.func.isRequired,
  icon: PropTypes.string,
};
